"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarEditModalButton = CarEditModalButton;
exports.CarAddNewModalButton = CarAddNewModalButton;
const react_1 = __importDefault(require("react"));
const GeneralModalButtons_1 = require("../../../View/Modals/GeneralModalButtons");
const CarsController_1 = require("../CarsController");
const CarModalBody_1 = require("./CarModalBody");
const CarValidationSchema_1 = require("./CarValidationSchema");
function CarEditModalButton({ modalProps: { onEdit, initialData } }) {
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralEditModalButton, { modalProps: {
            onEdit: onEdit,
            ModalBodyComponent: CarModalBody_1.CarModalBody,
            modalTitle: "Edycja samochodu",
            repository: CarsController_1.carsRepository,
            initialData: initialData,
            makeValidationSchema: CarValidationSchema_1.makeCarValidationSchema,
        }, buttonProps: {
            buttonVariant: "outline-success",
        } }));
}
function CarAddNewModalButton({ modalProps: { onAddNew } }) {
    return (react_1.default.createElement(GeneralModalButtons_1.GeneralAddNewModalButton, { modalProps: {
            onAddNew: onAddNew,
            ModalBodyComponent: CarModalBody_1.CarModalBody,
            modalTitle: "Dodaj samochód",
            repository: CarsController_1.carsRepository,
            makeValidationSchema: CarValidationSchema_1.makeCarValidationSchema,
        }, buttonProps: {
            buttonCaption: "Dodaj samochód",
            buttonVariant: "outline-success",
        } }));
}
